var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9818 11.9542C22.5131 11.9658 23.0474 11.9308 23.5765 11.9724C24.1124 12.0724 24.2416 12.8836 23.7655 13.1493C23.4406 13.3243 23.0548 13.2145 22.7026 13.2454H21.9818V11.9542ZM23.8837 10.4928C24.0017 10.9095 23.6001 11.2835 23.1989 11.2262H21.9818C21.9904 10.8333 21.9652 10.4068 21.9942 10.0346C22.4818 10.0484 22.9738 10.0066 23.4585 10.0564C23.6668 10.1088 23.8411 10.28 23.8837 10.4928ZM26.8126 4.31448C26.8353 5.11012 26.8159 5.94781 26.8224 6.75959C26.8209 10.06 26.8256 13.3603 26.8198 16.6609C26.7984 17.8978 25.7023 18.9726 24.4739 18.9972C23.2444 19.0022 22.0147 18.998 20.785 18.9994V14.0099C22.1248 14.003 23.4653 14.0239 24.8046 13.9994C25.4258 13.9604 26.1064 13.5505 26.1353 12.8668C26.2084 12.1801 25.5611 11.7051 24.9464 11.6301C24.7101 11.624 24.717 11.5613 24.9464 11.5339C25.5326 11.4072 25.993 10.8004 25.8205 10.1928C25.6735 9.55368 24.9671 9.30631 24.3796 9.30754C23.1816 9.2994 21.9833 9.30641 20.7852 9.30404C20.793 8.37256 20.7691 7.44008 20.7981 6.50928C20.893 5.2947 22.0168 4.29307 23.2279 4.3148C24.4229 4.31462 25.6178 4.31462 26.8126 4.31457V4.31448Z",
    fill: "url(#paint0_linear_4163_79693)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2465 6.63518C7.27709 5.40023 8.37797 4.33427 9.60473 4.31622C10.8297 4.31245 12.0549 4.31568 13.2799 4.31459C13.2765 8.44645 13.2865 12.5788 13.2748 16.7104C13.2276 17.9303 12.1388 18.976 10.9254 18.9976C9.69806 19.002 8.47062 18.9982 7.24327 18.9994V13.8417C8.43543 14.1234 9.68561 14.2432 10.9018 14.0564C11.6288 13.9395 12.4242 13.5824 12.6704 12.8282C12.8515 12.1831 12.7495 11.5041 12.7765 10.8419V9.30415H10.6717C10.6622 10.3212 10.6911 11.34 10.6565 12.3558C10.5997 12.9802 9.98139 13.3769 9.39251 13.3557C8.6622 13.3635 7.21499 12.8264 7.21499 12.8264C7.21135 10.9209 7.23618 8.53456 7.2465 6.63536V6.63518Z",
    fill: "url(#paint1_linear_4163_79693)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0648 9.92439C13.954 9.9479 14.0425 9.54701 14.0142 9.39494C14.0218 8.43341 13.9984 7.47083 14.0271 6.50998C14.1217 5.29026 15.2542 4.28613 16.4701 4.31468H20.0511C20.0477 8.44654 20.0577 12.5789 20.0461 16.7105C19.9988 17.9304 18.9099 18.976 17.6964 18.9977C16.4691 19.0023 15.2416 18.9984 14.0142 18.9996V13.3486C14.8525 14.0364 15.9918 14.1435 17.0361 14.1453C17.8235 14.145 18.6062 14.0237 19.3708 13.8421V12.8068C18.5091 13.2362 17.4962 13.509 16.5411 13.2623C15.8748 13.0965 15.3911 12.4525 15.4019 11.7649C15.3247 11.0498 15.7438 10.2949 16.4465 10.0823C17.319 9.80915 18.2699 10.018 19.0877 10.3732C19.2629 10.4649 19.4408 10.5787 19.3707 10.2858V9.47209C18.0029 9.14667 16.5473 9.02692 15.1732 9.38094C14.7754 9.49314 14.3879 9.6633 14.0648 9.92449V9.92439Z",
    fill: "url(#paint2_linear_4163_79693)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4163_79693",
    x1: 20.7437,
    y1: 11.343,
    x2: 26.7843,
    y2: 11.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4163_79693",
    x1: 7.11483,
    y1: 11.7976,
    x2: 13.1809,
    y2: 11.7976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4163_79693",
    x1: 14.0053,
    y1: 11.4854,
    x2: 20.05,
    y2: 11.4854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.fdf982b0.svg";
export { ForwardRef as ReactComponent };